(function() { module.exports = window["Vuex"]; }());